import { LINKS } from "@silo/types";
import { DescriptionExternalLink } from "../description";

export function DepositCurrentAprDescription(): JSX.Element {
  return (
    <div className="flex flex-col gap-2.5">
      <p>
        This is the current Annual Percentage Rate that the borrower will pay to
        you (minus the protocol fee). The interest rate varies according to the
        utilization rate and continuously accrues income on your deposit
        position.
      </p>

      <DescriptionExternalLink href={LINKS.SILOPEDIA.INTEREST} />
    </div>
  );
}

export function DepositProjectedAprDescription(): JSX.Element {
  return (
    <div className="flex flex-col gap-2.5">
      <p>
        The estimated Annual Percentage Rate that is expected to accrue after
        the transaction is completed. The value is calculated based on the
        projected utilization of the token asset in question.
      </p>

      <DescriptionExternalLink href={LINKS.SILOPEDIA.PROJECTED_APY} />
    </div>
  );
}
